export default __webpack_public_path__ + "759d4a3a70bd61a4369a42a93ec491d1.png";